/**
 * @generated SignedSource<<f09c61123539670a92a6b980cba24bd4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HiringProvidersQuery$variables = Record<PropertyKey, never>;
export type HiringProvidersQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"HiringProviders_query">;
};
export type HiringProvidersQuery = {
  response: HiringProvidersQuery$data;
  variables: HiringProvidersQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "HiringProvidersQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "HiringProviders_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "HiringProvidersQuery",
    "selections": [
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lang",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a3dfd2d8cf7e7ac5ba94c9f319227c94",
    "id": null,
    "metadata": {},
    "name": "HiringProvidersQuery",
    "operationKind": "query",
    "text": "query HiringProvidersQuery {\n  ...HiringProviders_query\n}\n\nfragment HiringProviders_query on Query {\n  company: companyDomainName {\n    lang\n    id\n  }\n}\n"
  }
};

(node as any).hash = "2021d8b5586e692023dc86b41e883e81";

export default node;
